import React from 'react';
import { Section } from './Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-brand-light" data-id="element-164">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-brand-dark to-[#0a1e2a] rounded-2xl p-6 md:p-10 border border-brand-accent/30 shadow-2xl relative overflow-hidden text-center" data-id="element-165">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-brand-accent/5 blur-[100px] pointer-events-none" data-id="element-166"></div>

        <ShieldCheck className="w-14 h-14 md:w-20 md:h-20 text-brand-accent mx-auto mb-4 relative z-10" data-id="element-167" />

        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-4 relative z-10" data-id="element-168">
          GARANTÍA STRETCHING RESUELTO — 7 DÍAS
        </h2>

        <p className="text-sm md:text-lg text-gray-300 mb-5 relative z-10 max-w-2xl mx-auto leading-relaxed" data-id="element-169">
          Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
          querés. Si en 7 días no es lo que esperabas:{' '}
          <strong className="text-white" data-id="element-170">Te devolvemos el 100%.</strong> Sin
          preguntas. Sin formularios. Sin drama.
        </p>

        <div className="bg-brand-light/50 p-4 rounded-xl border border-white/5 relative z-10" data-id="element-171">
          <p className="text-gray-400 text-xs md:text-sm italic" data-id="element-172">
            La confianza que tenemos en STRETCHING RESUELTO nos permite hacer
            esa promesa sin dudar. Más de 500 profes de Stretching de todo el
            país ya lo saben. La tasa de devoluciones es menor al 1%.
          </p>
        </div>
      </div>
    </Section>;
}